import React, { useEffect, lazy, Suspense } from 'react'
import { ThemeProvider, Icon, AuthenticationProvider } from '@rededor/crdsl'
import { Router, Switch, Route } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { AuthenticationProvider as InterceptorProvider } from '@rededor/request-interceptor'
import ProgressIcon from './components/StepBar/progressIcons/index'
import StepIcon from './components/StepBar/StepIcons/index'
import { handlerStartStepBar } from './store/stepbar/actions'
import { StepBarAction } from './store/stepbar/types'
import history from './utils/history'
import api from './consts/api'
import HelmetHelper from './utils/helpers/helmetHelper'
import ApplicationLoader from './components/ApplicationLoader'

// Lazy Componets
const Home = lazy(() => import('./pages/Home'))
const Consulta = lazy(() => import('./pages/Consulta'))
const PaginaNaoEncontrada = lazy(() => import('./components/NotFound'))

export interface IconProps {
  name?: string
  size?: number
}

const DivContainerStepBar = styled.div`
  @media screen and (max-width: 62rem) {
    padding-bottom: 60px;
  }
`

function App(): JSX.Element {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  localStorage.setItem('AP_CURRENT_LOCATION', '/paciente/marcar-consulta/')

  // alteraTokenDeAcessoLogadoEmAmbienteDev(
  //   '4caa54a5-9a22-3bf7-b5d8-fa78c644940d',
  //   '1625842855257'
  // )

  useEffect(() => {
    const stepBarConfig: StepBarAction[] = [
      {
        id: 1,
        name: 'especialidade-medico',
        titulo: t('Escolha Medico Especialidade'),
        icon: <StepIcon name="especialidadeGenerica" color="#BDBDBD" />,
        iconName: 'especialidadeGenerica',
        iconMobile: <Icon name="especialidadeGenerica" color="#BDBDBD" />,
        iconStats: <ProgressIcon type="initial" />,
        textColor: '#BDBDBD',
        preventClick: false,
        action: () => {
          // console.log('disparando ação especialidade/medico')
        }
      },
      {
        id: 2,
        name: 'local',
        titulo: t('Local'),
        icon: <StepIcon name="aGMUnidade" color="#BDBDBD" />,
        iconName: 'aGMUnidade',
        iconMobile: <Icon name="aGMUnidade" color="#BDBDBD" />,
        iconStats: <ProgressIcon type="initial" />,
        textColor: '#BDBDBD',
        preventClick: false,
        action: () => {
          // console.log('disparando ação local')
        }
      },
      {
        id: 3,
        name: 'paciente',
        titulo: t('Paciente'),
        icon: <StepIcon name="aGMPaciente" color="#BDBDBD" />,
        iconName: 'aGMPaciente',
        iconMobile: <Icon name="aGMPaciente" color="#BDBDBD" />,
        iconStats: <ProgressIcon type="initial" />,
        textColor: '#BDBDBD',
        preventClick: false,
        action: () => {
          // console.log('disparando ação paciente')
        }
      },
      {
        id: 4,
        name: 'pagamento',
        titulo: t('Plano'),
        icon: <StepIcon name="plano" color="#BDBDBD" />,
        iconName: 'plano',
        iconMobile: <Icon name="plano" color="#BDBDBD" />,
        iconStats: <ProgressIcon type="initial" />,
        textColor: '#BDBDBD',
        preventClick: false,
        action: () => {
          // console.log('disparando ação plano')
        }
      },
      {
        id: 5,
        name: 'agendar-consulta',
        titulo: t('Agende'),
        icon: <StepIcon name="aGMAgendar" color="#BDBDBD" />,
        iconName: 'aGMAgendar',
        iconMobile: <Icon name="aGMAgendar" color="#BDBDBD" />,
        iconStats: <ProgressIcon type="initial" />,
        textColor: '#BDBDBD',
        preventClick: false,
        action: () => {
          // console.log('disparando ação agende')
        }
      }
    ]
    dispatch(
      handlerStartStepBar({
        step: 1,
        title: t('AgDeEx'),
        stepConfig: stepBarConfig
      })
    )
  }, [t, dispatch])

  return (
    <>
      {HelmetHelper.incorporaScriptsDoHotjar()}
      {HelmetHelper.incorporaScriptsDoLgpd()}
      {HelmetHelper.adicionaTituloDaPagina()}
      <DivContainerStepBar>
        <Router history={history}>
          <ThemeProvider>
            <InterceptorProvider
              baseURL={api.areaDoPaciente}
              ignoredURL={[]}
              application={process.env.REACT_APP_APPLICATION_NAME}
              clientId={`${process.env.REACT_APP_CLIENT_ID}`}
              url401=""
              url403=""
            >
              <AuthenticationProvider
                urlPatient={`${api.areaDoPaciente}/paciente`}
                urlMenuLogged={`${api.areaDoPaciente}/menu-2`}
                urlMenuDisconnected={`${api.areaDoPaciente}/menu/aberto`}
              >
                <Switch>
                  <Route path="/paciente/marcar-consulta/teleconsulta/:usuario/:codigoDaRequisicao">
                    <Suspense fallback={<ApplicationLoader />}>
                      <Consulta />
                    </Suspense>
                  </Route>
                  <Route path="/paciente/marcar-consulta/pre-preenchida">
                    <Suspense fallback={<ApplicationLoader />}>
                      <Consulta />
                    </Suspense>
                  </Route>
                  <Route
                    path={[
                      '/paciente/marcar-consulta/:step/:stepPedido?',
                      '/PACIENTE/MARCAR-CONSULTA/:step/:stepPedido?'
                    ]}
                  >
                    <Suspense fallback={<ApplicationLoader />}>
                      <Consulta />
                    </Suspense>
                  </Route>
                  <Route path="/paciente/marcar-consulta">
                    <Suspense fallback={<ApplicationLoader />}>
                      <Consulta />
                    </Suspense>
                  </Route>
                  <Route exact path="/">
                    <Suspense fallback={<ApplicationLoader />}>
                      <Home />
                    </Suspense>
                  </Route>
                  <Route path="*">
                    <Suspense fallback={<ApplicationLoader />}>
                      <PaginaNaoEncontrada />
                    </Suspense>
                  </Route>
                </Switch>
              </AuthenticationProvider>
            </InterceptorProvider>
          </ThemeProvider>
        </Router>
      </DivContainerStepBar>
    </>
  )
}

export default App
